<template>
    <div class="parent">
        <div class="div1" style="height: 560px; overflow:hidden">
            <h3 style="text-align: center">{{data.type}}</h3>
            <p>some data here!</p>
        </div>
        <!-- <div style="display:flex;justify-content:space-between; background: linear-gradient(#000, #000) no-repeat center/2px 100%;"> -->
            <div class="div2" style="height: 560px">
                <div v-for="s in struct.order" :key="s">
                    <div v-if="data[s]">
                        <p style="display:inline">{{trans(s)}}</p>
                        <p style="display:inline">{{trans(data[s])}}</p>
                    </div>
                </div>

            </div>
            <div class="div3" style="height: 560px">
                <p>div 3</p>
                    <!-- <p style="display:inline">{{trans(item)}}</p> -->
                    <!-- <p style="display:inline">{{data.count[item]}}</p> -->
            </div>
        <!-- </div> -->
    </div>
</template>

<script>
    export default { 
        name: "pdfChecklist",
        props: ["data","struct"]
    }
</script>
<style scoped>
.parent {
    display: grid;
    grid-template-columns: repeat(2, 1fr);
    grid-template-rows: repeat(2, 1fr);
    grid-column-gap: 0px;
    grid-row-gap: 0px;
    overflow:hidden;
}
.div1 { grid-area: 1 / 1 / 2 / 3; background-color: red }
.div2 { grid-area: 2 / 1 / 3 / 2; background-color: gray}
.div3 { grid-area: 2 / 2 / 3 / 3; background-color: green}
</style>
<!-- <style scoped>
    .info-box {
        border-left: solid #1B608C 5px;
        width: 90vw;
        max-width: 900px;
        margin: 0px auto;
        margin-top: 20px;
        background-color: white;
        padding: 12px;
        box-sizing: border-box;
        -webkit-box-shadow: 2px 2px 5px 0px rgba(0,0,0,0.20);
        -moz-box-shadow: 2px 2px 5px 0px rgba(0,0,0,0.20);
        box-shadow: 2px 2px 5px 0px rgba(0,0,0,0.20);
    }
     h3 {
        font-weight: 400;
        font-size: 16px;
        margin-top: 0px;
    }
    span {
        font-size: 14px;
        font-weight: 300;
    }
</style> -->